/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Rule} from "../models/rule";
import { EventService } from "../services/event.service";
import {RulesService} from "../services/rules.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import { MouseEvent } from "createjs-module";

@Injectable()
//@Input() KHT - using the @Input() tag breaks certain resolvers after Angular 12 update
export class RuleEditorResolver implements Resolve<Rule> {

  constructor(
    private mRuleService: RulesService,
    private mEventService: EventService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Rule> {
    //Get the ID of the Rule which should be displayed in the editor from the Route Parameter
    const id = route.paramMap.get('id');
    console.log("Resolving Rule to edit from ID: " + id + "...");
    
    if (id == null || id.length == 0) {
      return null;
    } else {
      let rule: Rule;
      try {
        rule = await this.mRuleService.getRuleById(Number.parseInt(id, 10));
      } catch (error) {
        console.error("Problem resolving Rules... Error: " + error, error);
      }
      if (rule != null && rule.event != null) {
        try {
          rule.event = await this.mEventService.getEventById(rule.event.id);
        } catch (error) {
          console.error("Problem resolving Rule's Event Trigger for full information... Error: " + error, error); 
        }
      }
      return rule;
    }
  }

}
